<template>
  <TemplateDbsMyBooking v-if="isReadyToDraw" />
  <DialogInitialLoading v-else />

  <!-- 予約有効期限切れ時のダイアログ -->
  <DialogReservationExpired ref="DialogReservationExpired" />
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";
import dbsService from "@/services/dbs";
import TemplateDbsMyBooking from "@/views/Templates/Dbs/TemplateDbsMyBooking";

export default {
  name: "DbsMyBooking",
  components: {
    TemplateDbsMyBooking,
  },
  setup() {
    const store = useStore();
    const isReadyToDraw = ref(false);
    const DialogReservationExpired = ref(null);

    const router = useRouter();

    onMounted(async () => {
      try {
        // 予約チェックと同時に、予約情報を取得してstoreにセット
        if (await dbsService.isExpiredReservation()) {
          DialogReservationExpired.value.openDialog();
        } else {
          // reservationのレスポンスのidを使って、park情報を取得する
          const reservationInfo = store.getters["dbs/reservation"];

          // このページの前(index)で解錠してた場合はリダイレクト
          if (reservationInfo.status == "started") {
            router.push({
              name: "DbsMyUsing",
            });
          }

          await API.getDbsPark(reservationInfo.park_info.park_id);

          isReadyToDraw.value = true;
        }
      } catch (e) {
        console.log("Error in DbsMyBooking.onMounted()", e);
      }
    });

    return {
      isReadyToDraw,
      DialogReservationExpired,
    };
  },
};
</script>
